import type { BgColors, Colors } from '../../constants';
import { TextCaption } from '../Typography';

export interface ProgressBarProps {
  value: number;
  maxValue: number;
  label: string;
  showValueText?: boolean;
  progressColor?: BgColors;
  labelColor?: Colors;
}

export const ProgressBar = ({
  value,
  maxValue,
  label,
  showValueText = true,
  progressColor = 'bg-ds-accent2-300',
  labelColor = 'text-ds-natural',
}: ProgressBarProps) => {
  return (
    <div className="flex flex-col gap-1.5 items-center">
      <div className="flex items-center justify-between">
        <TextCaption
          label={label}
          color={labelColor}
        />
        {showValueText && <TextCaption label={`${value}/${maxValue}`} />}
      </div>
      <div className="h-1.5 w-full rounded-md bg-ds-natural-150 relative overflow-hidden">
        <div
          className={`h-full rounded-md absolute transition-all duration-300 ease-in-out ${progressColor}`}
          style={{
            width: `${Math.ceil((value / maxValue) * 100)}%`,
          }}
        />
      </div>
    </div>
  );
};
